<template>
    <div class="notfound__bck" :style="`background-image: linear-gradient(to right bottom, rgba(100,100,100,.3),  rgba(100,100,100,.3)) ,url('${$store.state.apiUrl}/images/static/background/large/bck_lost.webp');`" >
        <div class="hd__text">
            <h1 class="hd__heading">
                <span class="hd__text--title">Page not found</span>
                <span class="hd__text--subtitle">Sorry, the link you used doesn't exist.</span>
            </h1>
            <div class="hd__action">
                <router-link :to="{name:'Home'}" class="btn btn--white" id="btn-scroll-header" >Back to home page</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '../style/main';
.notfound{
    &__bck{
        height: calc(100vh - #{$nav-height});
        background-position: center;
        background-size: cover;
        
        margin-top: $nav-height;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

</style>